export interface Vehicle {
  id: number
  image: string
  gallery: string[]
  year: string
  make: string
  model: string
  trim: string
  price: string
  mileage: string
  engine: string
  transmission: string
  fuel: string
  color: string
  description: string
  equipment: string[]
  type: string
}

export const vehicles: Vehicle[] = [
  {
    id: 1,
    image:
      'https://cdn.magicpatterns.com/uploads/kMUQtDmS5zKr254W2hMeYS/IMG_5685.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/kMUQtDmS5zKr254W2hMeYS/IMG_5685.jpg',
      'https://cdn.magicpatterns.com/uploads/kMUQtDmS5zKr254W2hMeYS/IMG_5684.jpg',
      'https://cdn.magicpatterns.com/uploads/kMUQtDmS5zKr254W2hMeYS/IMG_5687.jpg',
      'https://cdn.magicpatterns.com/uploads/kMUQtDmS5zKr254W2hMeYS/IMG_5688.jpg',
      'https://cdn.magicpatterns.com/uploads/kMUQtDmS5zKr254W2hMeYS/IMG_5689.jpg',
      'https://cdn.magicpatterns.com/uploads/kMUQtDmS5zKr254W2hMeYS/IMG_5690.jpg',
    ],
    year: '2021',
    make: 'Ford',
    model: 'Ranger',
    trim: 'XL',
    price: '$20.900',
    mileage: '130.000 km',
    engine: '3.2L Puma TDCi',
    transmission: 'Automática 6 vel.',
    fuel: 'Diésel',
    color: 'Gris Plata',
    description:
      'Excelente estado, único dueño. Mantenimientos al día en concesionario oficial. Ideal para trabajo y familia. Cuenta con accesorios originales Ford.',
    equipment: [
      'Llantas de aleación 17"',
      'Pantalla táctil 8" con SYNC 3',
      'Cámara de retroceso',
      'Sensores de estacionamiento',
      'Control de velocidad crucero',
      'Climatizador automático bizona',
    ],
    type: 'Camionetas',
  },
  {
    id: 2,
    image:
      'https://images.unsplash.com/photo-1609521263047-f8f205293f24?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1609521263047-f8f205293f24?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1553440569-bcc63803a83d?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1600049255855-49298463372c?auto=format&fit=crop&w=1200&q=80',
    ],
    year: '2023',
    make: 'Ford',
    model: 'F150',
    trim: 'Raptor',
    price: '$72.998',
    mileage: '17K km',
    engine: '3.5L V6 EcoBoost High Output',
    transmission: 'Automática 10 vel.',
    fuel: 'Nafta',
    color: 'Azul',
    description:
      'La pick-up más extrema del mercado. Suspensión FOX Racing, modos de manejo Baja y Rock Crawl. Estado inmaculado, lista para la aventura.',
    equipment: [
      'Amortiguadores FOX Racing Shox',
      'Techo panorámico',
      'Sistema de audio B&O',
      'Asientos de cuero calefaccionados y ventilados',
      'Cámara 360°',
      'Pro Trailer Backup Assist',
    ],
    type: 'Deportivos',
  },
  {
    id: 3,
    image:
      'https://images.unsplash.com/photo-1583122620071-59c3f1a165d1?auto=format&fit=crop&w=800&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1583122620071-59c3f1a165d1?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1559416523-140ddc3d238c?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?auto=format&fit=crop&w=1200&q=80',
    ],
    year: '2022',
    make: 'Ram',
    model: '1500',
    trim: 'Bighorn',
    price: '$37.998',
    mileage: '24K km',
    engine: '5.7L HEMI V8',
    transmission: 'Automática 8 vel.',
    fuel: 'Nafta',
    color: 'Negro',
    description:
      'Potencia y confort en su máxima expresión. Interior espacioso y lujoso. Motor V8 HEMI con sistema de desconexión de cilindros para mayor eficiencia.',
    equipment: [
      'Pantalla Uconnect 12"',
      'Llantas 20"',
      'Estribos laterales',
      'Arranque a distancia',
      'Asientos con ajuste eléctrico',
      'Apple CarPlay / Android Auto inalámbrico',
    ],
    type: 'SUVs',
  },
]
